import i18next from "i18next"

export const getAppToastOptions = ({
  title,
  icon = "success",
  timer = 5000,
}) => {
  const isRtl =
    i18next.language === "sa" ||
    document.documentElement.getAttribute("dir") === "rtl"

  return {
    toast: true,
    icon,
    title,
    position: isRtl ? "top-start" : "top-end",
    showConfirmButton: false,
    timer,
    width: "auto",
    customClass: {
      popup: "app-toast-popup",
    },
  }
}
